/**
 * custom-article.js
 * PHOTOPRI — Blog Interactive Elements
 * "The Gallery Spotlight" Edition
 *
 * アーティスト特化の有機的インタラクションを提供します。
 * 1. IntersectionObserver によるスタガー・フェードイン
 * 2. マウス座標を追従する「スポットライト」エフェクト（PCのみ）
 */

document.addEventListener('DOMContentLoaded', () => {
  /* =========================================================================
     1. スクロール時のフェードイン（IntersectionObserver）
     ========================================================================= */
  const offerCards = document.querySelectorAll('.st-premium-offer-card');

  if (offerCards.length > 0) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });

    offerCards.forEach(card => observer.observe(card));
  }

  /* =========================================================================
     2. スポットライト追従（Spotlight Tracking）
     PCのみ。カード内でマウスが動くと、CSS変数を更新して光が追従する。
     ========================================================================= */
  const isPointerDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (isPointerDevice) {
    document.querySelectorAll('[data-spotlight]').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        card.style.setProperty('--mouse-x', x + '%');
        card.style.setProperty('--mouse-y', y + '%');
      });

      card.addEventListener('mouseleave', () => {
        // マウスが離れたらスポットライトを中央へゆっくり戻す
        card.style.setProperty('--mouse-x', '50%');
        card.style.setProperty('--mouse-y', '50%');
      });
    });
  }
});
